<template>
  <v-overlay v-model="localLoading" class="align-center justify-center">
    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
  </v-overlay>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 64,
    },
  },
  emits: ["update:loading"],
  data() {
    return {
      localLoading: this.loading,
    };
  },
  watch: {
    loading(val) {
      this.localLoading = val;
    },
    localLoading(val) {
      if (!val) this.$emit("update:loading", val);
    },
  },
};
</script>
